import classNames from "classnames/bind";
import RegisterContainer from "../../Register/RegisterContainer";
import WellcomeContainer from "../../Register/WellcomeContainer";
import styles from "./WellcomeBack.module.css";
// eslint-disable-next-line
const cx = classNames.bind(styles)

function WellcomeBack() {
    return (
        <RegisterContainer>
            <WellcomeContainer
                back={'/forgot-password/verify-token'}
                title={'Đổi mật khẩu thành công'}
                description={'Đăng nhập lại để tiếp tục sử dụng'}
            />
        </RegisterContainer>
    )
}

export default WellcomeBack